import { motion } from 'framer-motion';

interface WinnerCardProps {
  prizeName: string;
  winnerName: string;
  delayIndex: number;
}

export function WinnerCard({ prizeName, winnerName, delayIndex }: WinnerCardProps) {
  const getMedalEmoji = (prize: string) => {
    switch (prize) {
      case 'Full House':
        return '🥇';
      case 'Early Five':
        return '🥉';
      default:
        return '🥈';
    }
  };

  return (
    <motion.div
      initial={{ x: -20, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ delay: delayIndex * 0.1, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      style={{
        boxShadow: '0 4px 12px rgba(0,0,0,0.3), inset 0 0 12px rgba(255,255,255,0.01)',
      }}
      className="glass-light p-3.5 rounded-2xl border border-white/5 flex items-center justify-between hover:border-purple-500/20 transition-all select-none"
    >
      <div className="flex items-center space-x-3 text-left">
        <div className="w-9 h-9 rounded-full bg-purple-600/10 border border-purple-500/20 flex items-center justify-center text-lg shadow-inner">
          {getMedalEmoji(prizeName)}
        </div>
        <div className="flex flex-col">
          <span className="text-[10px] font-black uppercase tracking-wider text-amber-400">
            {prizeName}
          </span>
          <span className="text-xs font-bold text-white tracking-wide truncate max-w-[120px]">
            {winnerName}
          </span>
        </div>
      </div>
      <span className="px-2 py-0.5 rounded bg-purple-500/10 border border-purple-500/20 text-[8px] font-black uppercase tracking-wider text-purple-400">
        Verified
      </span>
    </motion.div>
  );
}
